const BETTER_DOC_SPECIALTIES = {
  ALLERGOLOGY_AND_CLINICAL_IMMUNOLOGY: { betterDocKey: "allergology_and_immunology", subSpecialties: [] },
  GENERAL_INTERNAL_MEDICINE: { betterDocKey: "internal_medicine", subSpecialties: ["geriatrics"] },
  ANESTHESIOLOGY: { betterDocKey: "anesthesiology", subSpecialties: [] },
  ANGIOLOGY: { betterDocKey: "angiology", subSpecialties: [] },
  OCCUPATIONAL_MEDICINE: { betterDocKey: "occupational_med", subSpecialties: [] },
  SURGERY: { betterDocKey: "surgery", subSpecialties: ["traumatology", "visceral_surgery", "surgical_senology"] },
  DERMATOLOGY_AND_VENEREOLOGY: { betterDocKey: "derma_and_venerology", subSpecialties: [] },
  ENDOCRINOLOGY_AND_DIABETOLOGY: { betterDocKey: "endocrinology_diabetes", subSpecialties: [] },
  GASTROENTEROLOGY: { betterDocKey: "gastroenterology", subSpecialties: ["hepatologie"] },
  VASCULAR_SURGERY: { betterDocKey: "vasc_surgery", subSpecialties: [] },
  GYNECOLOGY_AND_OBSTETRICS: {
    betterDocKey: "gynecology_and_obstetrics",
    subSpecialties: [
      "operative_gynecology_and_obstetrics",
      "gynecologic_oncology",
      "fetomaternal_medicine",
      "reproductive_medicine_and_gynecological_endo",
      "urogynecology",
      "gynecological_senology",
    ],
  },
  HEMATOLOGY: { betterDocKey: "hematology", subSpecialties: [] },
  HAND_SURGERY: { betterDocKey: "hand_surgery", subSpecialties: [] },
  CARDIAC_AND_THORACIC_VASCULAR_SURGERY: { betterDocKey: "heart_thoracic_surgery", subSpecialties: [] },
  INFECTIOLOGY: { betterDocKey: "infectious_diseases", subSpecialties: ["infection_prevention_and_control"] },
  INTENSIVE_CARE_MEDICINE: { betterDocKey: "intensive_care", subSpecialties: [] },
  CARDIOLOGY: { betterDocKey: "cardiology", subSpecialties: [] },
  PEDIATRICS_AND_ADOLESCENT_MEDICINE: {
    betterDocKey: "pediatric_medicine",
    subSpecialties: [
      "pediatric_endocrinology_diabetology",
      "pediatric_gastroenterology_and_hepatology",
      "pediatric_cardiology",
      "neonatology",
      "pediatric_nephrology",
      "neuropaediatrics",
      "pediatric_oncology_hematology",
      "pediatric_pneumology",
      "pediatric_rheumatology",
      "developmental_pediatrics",
      "pediatric_emergency_medicine",
    ],
  },
  PEDIATRIC_SURGERY: { betterDocKey: "pediatric_surgery", subSpecialties: ["pediatric_emergency_med"] },
  CLINICAL_PHARMACOLOGY_AND_TOXICOLOGY: { betterDocKey: "pharmacology_toxicology", subSpecialties: [] },
  MEDICAL_GENETICS: { betterDocKey: "medical_genetics", subSpecialties: [] },
  MEDICAL_ONCOLOGY: { betterDocKey: "medical_oncology", subSpecialties: [] },
  MAXILLOFACIAL_SURGERY: { betterDocKey: "oral_and_maxillofacial_surgery", subSpecialties: [] },
  NEPHROLOGY: { betterDocKey: "nephrology", subSpecialties: [] },
  NEUROSURGERY: { betterDocKey: "neurosurgery", subSpecialties: [] },
  NEUROLOGY: { betterDocKey: "neurology", subSpecialties: [] },
  NUCLEAR_MEDICINE: { betterDocKey: "nuclear_medicine", subSpecialties: [] },
  OPHTHALMOLOGY: { betterDocKey: "ophthalmology", subSpecialties: ["ophthalmology"] },
  ORTHOPEDIC_SURGERY_AND_TRAUMATOLOGY_OF_THE_MUSCULOSKELETAL_SYSTEM: {
    betterDocKey: "orthopaedic_surg_and_traumatology",
    subSpecialties: [],
  },
  OTO_RHINO_LARYNGOLOGY: { betterDocKey: "otorhinolaryngology", subSpecialties: ["ear_nose_throat_phoniatrics"] },
  PATHOLOGY: { betterDocKey: "pathology", subSpecialties: ["cytopathology_mol_pathology"] },
  PHARMACEUTICAL_MEDICINE: { betterDocKey: "pharmaceutical_med", subSpecialties: [] },
  PHYSICAL_MEDICINE_AND_REHABILITATION: { betterDocKey: "physical_med_and_rehab", subSpecialties: [] },
  PLASTIC_RECONSTRUCTIVE_AND_AESTHETIC_SURGERY: {
    betterDocKey: "plastic_reconstructive_asthetic_surg",
    subSpecialties: [],
  },
  PNEUMOLOGY: { betterDocKey: "pneumology", subSpecialties: [] },
  PREVENTION_AND_HEALTH_CARE: { betterDocKey: "prevention_and_public_health", subSpecialties: [] },
  RADIOLOGY: {
    betterDocKey: "radiology",
    subSpecialties: ["pediatric_radiology", "diagnostic_neuroradiology", "invasive_neuroradiology"],
  },
  RADIO_ONCOLOGY_AND_RADIOTHERAPY: { betterDocKey: "radiooncology_radiotherapy", subSpecialties: [] },
  FORENSIC_MEDICINE: { betterDocKey: "forensic_med", subSpecialties: [] },
  RHEUMATOLOGY: { betterDocKey: "rheumatology", subSpecialties: [] },
  THORACIC_SURGERY: { betterDocKey: "thoracic_surgery", subSpecialties: [] },
  TROPICAL_AND_TRAVEL_MEDICINE: { betterDocKey: "tropical_and_travel_med", subSpecialties: [] },
  UROLOGY: { betterDocKey: "urology", subSpecialties: ["operative_urology", "neurourology", "urology_for_women"] },
} as const satisfies Record<string, { betterDocKey: string; subSpecialties: readonly string[] }>

type BetterDocSpecialty = keyof typeof BETTER_DOC_SPECIALTIES

const isSpecialtyEligibleForBetterDoc = (specialty: string): specialty is BetterDocSpecialty =>
  Object.hasOwn(BETTER_DOC_SPECIALTIES, specialty)

const getBetterDocSubSpecialty = (specialty: BetterDocSpecialty): readonly string[] =>
  BETTER_DOC_SPECIALTIES[specialty].subSpecialties

const findBetterDocSpecialtyByKey = (betterDocKey: string | undefined): BetterDocSpecialty | undefined =>
  Object.keys(BETTER_DOC_SPECIALTIES)
    .filter(isSpecialtyEligibleForBetterDoc)
    .find((specialty) => BETTER_DOC_SPECIALTIES[specialty].betterDocKey === betterDocKey)

export {
  type BetterDocSpecialty,
  findBetterDocSpecialtyByKey,
  getBetterDocSubSpecialty,
  isSpecialtyEligibleForBetterDoc,
}
